import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import {
  ClipboardList, NotebookPen, MessageCircle, CalendarDays, HeartHandshake, BookOpen, Target, ChevronRight,
} from "lucide-react";

const SECTIONS = [
  { to: "/atividades", label: "Atividades e respostas", desc: "Tarefas, respostas enviadas e progresso", icon: ClipboardList },
  { to: "/registro", label: "Meu registro", desc: "Textos, áudios, transcrições, imagens e documentos", icon: NotebookPen },
  { to: "/mensagens", label: "Mensagens e orientações", desc: "Conversas e recomendações do seu profissional", icon: MessageCircle },
  { to: "/conteudos", label: "Conteúdos indicados", desc: "Materiais recomendados para você", icon: BookOpen },
  { to: "/agenda", label: "Agenda", desc: "Próximas sessões e histórico", icon: CalendarDays },
  { to: "/rede-apoio", label: "Rede de apoio", desc: "Pessoas que apoiam sua jornada", icon: HeartHandshake },
];

export default function MinhaJornada() {
  const nav = useNavigate();
  return (
    <div className="max-w-3xl mx-auto space-y-5 animate-fade-up" data-testid="minha-jornada">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F3B4D] flex items-center gap-2">
          <Target className="text-[#0F766E]" /> Minha Jornada
        </h1>
        <p className="text-sm text-[#94A3B8]">Todo o seu acompanhamento reunido em um só lugar.</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {SECTIONS.map((s) => {
          const Icon = s.icon;
          return (
            <Card
              key={s.to}
              data-testid={`jornada-${s.to.slice(1)}`}
              onClick={() => nav(s.to)}
              className="rounded-2xl p-4 border-[#E0F2FE] card-hover cursor-pointer flex items-center gap-3"
            >
              <div className="w-11 h-11 rounded-xl bg-[#0F766E]/10 grid place-items-center shrink-0">
                <Icon className="text-[#0F766E]" size={20} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-[#1F3B4D]">{s.label}</div>
                <div className="text-xs text-[#94A3B8] mt-0.5">{s.desc}</div>
              </div>
              <ChevronRight size={18} className="text-[#94A3B8] shrink-0" />
            </Card>
          );
        })}
      </div>
    </div>
  );
}
